import { Currency } from 'src/shared/enum/Currency';

const currencySymbols: { [key in Currency]: string } = {
    [Currency.GBP]: '£',
    [Currency.EUR]: '€',
};

export const getCurrencySymbol = (currency: Currency): string =>
    currencySymbols[currency] || currencySymbols[Currency.GBP];
